import { createClient, SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl: string | undefined = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey: string | undefined = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error(
    "Missing environment variable: REACT_APP_SUPABASE_URL. " +
      "Copy .env.example to .env.local and fill in your Supabase project URL."
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    "Missing environment variable: REACT_APP_SUPABASE_ANON_KEY. " +
      "Copy .env.example to .env.local and fill in your Supabase anon key."
  );
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);
